<script>
	import { onMount } from 'svelte';
	import * as d3 from 'd3';
    import * as d3Tip from 'd3-tip';
	// var data = [ {start: 5, width:30,  color:'#EEAC4D', label:"seed"},
    // {start: 35, width:65, color:'#6C3400', label:"plant"}, 
    // {start: 100, width:100,  color:'#506432', label:"grow"}, 
    // {start: 200, width:14,  color:'#B30019', label:"harvest"}];
    import { createEventDispatcher } from "svelte";
    export let data;
    import seeds from "../../components/Seeds/seeds-store.js";

    // $: console.log(data)   
    // var data = [{'label': 'seed', 'start': 103, 'width': 7, 'color': '#EEAC4D'}, {'label': 'plant', 'start': 110, 'width': 7, 'color': '#6C3400'}, {'label': 'grow', 'start': 165, 'width': 55, 'color': '#506432'}, {'label': 'harvest', 'start': 179, 'width': 14, 'color': '#B30019'}]
    
    const dispatch = createEventDispatcher();

	let el;

	onMount(() => {

        const plotWidth = 1000;
        const plotHeight = 150;
        const margin = {top:5, right:5, bottom:30, left:170};
        const graphWidth = plotWidth - margin.left - margin.right;
        const graphHeight =  plotHeight - margin.top - margin.bottom;

        const x = d3.scaleLinear()
        .domain([0, 365])
        .range([0,graphWidth]);

        const y = d3.scaleBand()
        .domain(data.map(item => item.label))
        .range([0, graphHeight])
        .paddingInner(0.2)
        .paddingOuter(0.2);

		const svg = d3.select(el)
            .append('svg')
            .attr("width", plotWidth)
            .attr("height", plotHeight)
            
        const graph = svg.append('g')
            .attr("width", graphWidth)
            .attr("height", graphHeight)
            .attr("transform", `translate(${margin.left}, ${margin.top})`)			
        
        const rects = graph.selectAll("rect")
            .data(data)
            .enter()
            .append('rect')
            .attr("width", (d) =>  x(d.width))
            .attr("height", y.bandwidth)
            .attr("fill", (d) => d.color)
            .attr("y", d => y(d.label))
            .attr("x", d => x(d.start))
            .on("click", handleClick);

    // const tip = d3Tip.tip()
    // .attr('class', 'tip card')
    // .html( d=> {
    //     return `<p>hello there</p>`}
    //     );

    // graph.call(tip);

        svg.selectAll("rect").on("mouseover", (d,i,n) =>{
            // tip.show(d, d.target);
            handleMouseOver(d,i,n)
        })
        svg.selectAll("rect").on("mouseout", handleMouseOut)
        svg.selectAll("rect").on("click", handleClick)

        const xAxisGroup = graph.append('g');
        const yAxisGroup = graph.append('g');

        const xAxis = d3.axisBottom(x).ticks(6);
        const yAxis = d3.axisLeft(y);

        xAxisGroup.call(xAxis)
        .attr("transform", `translate(0, ${graphHeight})`);
        yAxisGroup.call(yAxis);
        
        xAxisGroup.selectAll('text')
        .attr('transform', 'rotate(-40)')
        .attr('text-anchor', 'end');
	});

    const handleClick = d => {
        if (d.target.__data__.plotElement == 'start_germ_out') {
            dispatch("toggleseeds", d.target.__data__.plantName);
        } 
        if (d.target.__data__.plotElement == 'start_germ_in') {
            dispatch("toggleseeds", d.target.__data__.plantName);
        } 
        if (d.target.__data__.plotElement == 'start_grow') {
            dispatch("togglegrow", d.target.__data__.plantName);
        } 
        if (d.target.__data__.plotElement == 'start_harvest') {
            dispatch("toggleharvest", d.target.__data__.plantName);
        } 
        
    };

    const handleMouseOver = (d) => {
        // console.log(d)
        d3.select(d.target).transition('changeBarFill').duration(300).attr("fill", (d) => d.colorDim)
    };

    const handleMouseOut = (d) => {
        // console.log(d)
        d3.select(d.target).transition('changeBarFill').duration(300).attr("fill", (d) => d.color)
    };


</script>

<style>
	.chart :global(div) {
		text-align: right;
		color: white;
        font-weight: 200;
        font-size: var(--text-05);
	}
</style>

<div bind:this={el} class="chart">
</div>